import {AfterViewChecked, AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {
  AlertController,
  AnimationController,
  IonContent,
  ModalController,
  NavController,
  PopoverController
} from '@ionic/angular';
import {NativeAudio} from "@capgo/native-audio";
import {PostModel, ProductModel} from 'src/app/models/post.model';
import {PostService} from 'src/app/services/post/post.service';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Location} from '@angular/common';
import {GlobalService} from 'src/app/services/global/global.service';
import {ApiResponse, sdgActive, sdgInactive, sdgs} from 'src/app/services/utils';
import {UserService} from 'src/app/services/user/user.service';
import {AuthService} from 'src/app/services/auth/auth.service';
import {UserModel} from 'src/app/models/user.model';
import {TranslateService} from '@ngx-translate/core';
import {CommentsComponent} from 'src/app/components/comments/comments.component';
import {TagUserComponent} from 'src/app/components/tag-user/tag-user.component';
import {StorageService} from '../../../services/storage/storage.service';
import {ImageViewerComponent} from '../../../modal/image-viewer/image-viewer.component';
import {ShareService} from "../../../services/share/share.service";
import {SetMetaService} from "../../../services/set-meta/set-meta.service";
import Swiper, {Pagination} from "swiper";
import {Capacitor} from "@capacitor/core";
import {GalleryModalComponent} from "../../../modal/gallery-modal/gallery-modal.component";
import {NavigationService} from "../../../services/navigations/navigation.service";
import {CompanyModel} from "../../../models/company.model";
import {ActionPointService} from "../../../services/action-points/action-point.service";

Swiper.use([Pagination]);

@Component({
  selector: 'app-view-post',
  templateUrl: './view-post.page.html',
  styleUrls: ['./view-post.page.scss'],
  standalone: false
})
export class ViewPostPage implements OnInit, AfterViewChecked, AfterViewInit {
  @Input() item: PostModel | undefined;
  @ViewChild('content') pageContent: IonContent;
  @ViewChild('commentInputElement') commentInput: ElementRef<HTMLTextAreaElement>;
  @ViewChild(CommentsComponent) commentsComponent: CommentsComponent;
  @ViewChild(TagUserComponent) tagUserComponent: TagUserComponent;
  @ViewChild('footertag') footertag: ElementRef;
  @ViewChild('reactionRow') reactionRow: ElementRef;
  @ViewChild('swiperContainer', {static: false}) swiperContainer: ElementRef;

  commentForm: UntypedFormGroup;
  errorMessage = [];
  pagination = 1;
  comments = [];
  body: any;
  likeButtonDisabled = false;
  createdTime: string;
  commentType = 'new';
  user: UserModel;
  parentId = 0;
  translateFlag = false;
  postType = 'post';
  translateCommentFlag = [] as any;
  translateComment = [] as any;
  products: ProductModel[];
  isRatingDisabled = false;
  commentScrollBottom = 'no';
  sdgs2 = [];
  swiper: Swiper;
  sdgActiveArray = sdgActive;
  adoptPost = true;
  reasonNotAdoptOwn = true;
  totalUsersRatedCount = 0;

  findIndex = 0;
  tagSelectedFlag = false;
  userSelectedTags: UserModel[] = [];
  colorOfEarth: string;

  scrollCounter = 0;

  momentPagination: number = 1;

  swiperInitialized: boolean = false;
  isBrowser: boolean = true;
  showCommentBox: boolean = false;
  loadingComplete: boolean = false;
  hasMoreMoments: boolean = true;
  loadingMoments: boolean = false;
  galleryIsOpen: boolean = true;
  isMobileScreen: boolean = false;

  private imageViewModal?: any;
  private modalElement?: any;

  public loading: boolean = false;

  moments: PostModel[] = [];

  constructor(
    private navController: NavController,
    private postService: PostService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private popoverCtrl: PopoverController,
    private userService: UserService,
    public auth: AuthService,
    public globalService: GlobalService,
    public translate: TranslateService,
    private storage: StorageService,
    private alertController: AlertController,
    private modalController: ModalController,
    private shareService: ShareService,
    private setMeta: SetMetaService,
    private animationCtrl: AnimationController,
    private navigationService: NavigationService,
    private actionPointService: ActionPointService,
  ) {
    this.isBrowser = globalService.isBrowser;
    if (window.innerWidth < 500) {
      this.isMobileScreen = true
    }

    this.sdgs2 = sdgs;
    this.sdgs2.forEach(sdg => {
      sdg.checked = false;
    });
    this.commentForm = new UntypedFormGroup({
      comment: new UntypedFormControl(
        '', Validators.required
      ),
      commentId: new UntypedFormControl(
        '', null
      ),
    });
  }

  resize() {
    this.tagSelectedFlag = false;
    this.commentInput.nativeElement.style.height = 'auto';
    this.commentInput.nativeElement.style.height = this.commentInput.nativeElement.scrollHeight + 'px';
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.user = this.auth.user;
      this.auth.getUserStatus.subscribe(() => {
        this.user = this.auth.user;
      });
    }


    this.activatedRoute.queryParams.subscribe(params => {
      const shouldShow = params['comment'] === 'true' || params['comment'] === '1';
      if (shouldShow) {
        this.showCommentBox = true;
      }
    });


    this.postType = this.activatedRoute.snapshot.params.postType;
    if (this.postType === 'post') {
      this.loadPost(this.activatedRoute.snapshot.params.postId);
    }
    if (this.postType === 'action_point' || this.postType === 'adopted_action_point') {
      this.loadActionPoint(this.activatedRoute.snapshot.params.postId);
    }

    this.postService.postSubject.subscribe(val => {
      if (this.item && val !== null && val.id === this.item?.id) {
        this.item = val;
        if (val.type === 'action_point') {
          this.loadActionPoint(this.activatedRoute.snapshot.params.postId);
        }
      }
    });

    if (this.activatedRoute.snapshot.params.type === 'comment') {
      this.commentScrollBottom = 'yes';
    }

    this.globalService.languageEvent.subscribe(val => {
      if (val !== '') {
        this.createdTime = this.globalService.timeSince(this.item?.createdAt);
      }
    });

    this.commentForm.get('comment').valueChanges.subscribe((val: any) => {
      if (val?.lastIndexOf('@') !== -1 && val?.lastIndexOf('@') > val?.lastIndexOf(' ') && this.tagSelectedFlag === false) {
        this.findIndex = val.lastIndexOf('@');
        const newVal = val.substring(this.findIndex + 1, val.length);
        this.tagUserComponent.getItems(newVal);

      }
      if (val?.lastIndexOf('@') === -1) {
        this.tagUserComponent.getItems('');
        if (this.footertag?.nativeElement) {
          this.footertag.nativeElement.style.height = '50px';
        }
      }
    });

    this.shareService.sharedLinkCounter.subscribe({
      next: () => {
        this.item.sharesCount += 1;
      }
    });
  }

  ngAfterViewInit() {
    this.tryInitializeSwiper();
  }

  ionViewWillLeave() {
    this.setMeta.setMetaData('', '', '');
  }

  initSwiperFunc() {
    this.swiper = new Swiper(this.swiperContainer.nativeElement, {
      loop: false,
      autoplay: true,
      slidesPerView: 6,
      slidesPerGroup: 6,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }
    });
    if (this.swiper) {
      this.swiper.init();
    }
  }

  async ngAfterViewChecked() {
    if (this.reactionRow && this.reactionRow.nativeElement.getBoundingClientRect().top !== 0) {
      this.scrollCounter++;
    }
    if (this.scrollCounter === 1) {
      if (this.commentScrollBottom === 'yes') {
        const fromTop = this.reactionRow.nativeElement.getBoundingClientRect().top - 56;
        await this.pageContent.scrollToPoint(10, fromTop, 300);
      }
    }

    if (!this.swiperInitialized) {
      this.tryInitializeSwiper();
    }
  }

  tryInitializeSwiper() {
    if (this.swiperContainer && this.isElementVisible(this.swiperContainer.nativeElement)) {
      this.initSwiperFunc();
      this.swiperInitialized = true;
    }
  }

  isElementVisible(element: HTMLElement): boolean {
    if (this.globalService.isBrowser) {
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    } else {
      return false;
    }
  }

  selectedUser(event) {
    if (!event?.user) return;

    this.userSelectedTags.push(event.user);
    this.tagSelectedFlag = true;

    if (this.footertag?.nativeElement) {
      this.footertag.nativeElement.style.height = '50px';
    }

    const str = this.commentForm.get('comment').value;
    this.commentForm.get('comment').setValue(
      str.substring(0, this.findIndex) + '@' + event.user.username + ' '
    );

    setTimeout(() => {
      const inputEl = this.commentInput?.nativeElement;
      if (inputEl) {
        const val = inputEl.value.length;
        inputEl.setSelectionRange(val, val);
        inputEl.focus();
      }
    }, 50);
  }


  loadPost(postId: string) {
    this.postService.loadPostWithMeta(postId).subscribe({
      next: (data) => {
        this.item = data.post;
        this.createdTime = data.createdTime;
        this.setMeta.setMetaData(data.metaTitle, data.metaDescription, data.image);
        this.commentsComponent?.loadCommentByComponent();
      },
      error: (err) => {
        this.errorMessage = err.message;
      }
    });
  }

  loadActionPoint(postId: string) {
    this.actionPointService.loadActionPointData(postId, this.sdgs2).subscribe({
      next: (data) => {
        this.item = data.item;
        this.products = data.products;
        this.createdTime = data.createdTime;
        this.totalUsersRatedCount = data.totalUsersRatedCount;
        this.sdgs2 = data.sdgsUpdated;

        this.setMeta.setMetaData(this.item.title, this.item.description, data.image);
        this.commentsComponent?.loadCommentByComponent();
        this.setColorOfRatingButton(this.item.star);

        this.loadMoments();
        this.viewAdopt();
      },
      error: (err) => {
        this.errorMessage = err;
        this.viewAdopt();
      }
    });
  }


  loadMoments(): Promise<void> {
    return new Promise((resolve) => {
      if (this.loadingMoments || !this.hasMoreMoments) {
        resolve();
        return;
      }

      this.loadingMoments = true;

      this.postService.apiGetActionPointMoments(this.item.id.toString(), this.momentPagination).subscribe((result: ApiResponse) => {
        this.loadingMoments = false;

        if (result.status && Array.isArray(result.data.data)) {
          const newMoments = result.data.data;
          const pagination = result.data.pagination;


          if (newMoments.length > 0) {
            this.moments = [...this.moments, ...newMoments];

            if (pagination.nextPageUrl) {
              this.momentPagination++;
            } else {
              this.hasMoreMoments = false;
            }
          } else {
            this.hasMoreMoments = false;
          }
        } else {
          this.hasMoreMoments = false;
        }
        resolve();
      });
    });
  }


  handleInfinite(event: any) {
    this.loadMoments().then(() => {
      event.target.complete();
    });
  }

  openLink(url) {
    window.open(url, '_system');
  }

  loadMoreComments(event) {
    if (this.item && this.item.commentsCount > 3) {
      this.commentsComponent.loadMoreComments(event);
    } else {
      event.target.complete();
      this.loadingComplete = true;
    }
  }

  listPost(item) {
    if (this.auth && this.auth.isAuthenticated) {
      this.likeButtonDisabled = true;
      const data = {postId: item?.id};

      this.postService.apiLikeActionPoint(data).subscribe(async (result: ApiResponse) => {
        if (result.status) {
          this.item = result.data;
          this.postService.postEvent.next(this.item);
          if (result.data.isLiked && Capacitor.isNativePlatform() && await this.storage.isInteractionSoundOn()) {
            NativeAudio.play({
              assetId: 'like',
              time: 0
            });
          }
        }
        this.likeButtonDisabled = false;
      });
    } else {
      this.isAnonymousAction();
    }

  }

  async openInteraction(item, type) {
    await this.navigationService.openInteraction(item, type);
  }

  openOtherProfile(id) {
    this.navigationService.openOtherUserProfile(id, this.item.createdBy.isDeleted);
  }

  async editPost(item) {
    this.popoverCtrl.dismiss();
    if (item.type === 'post') {
      await this.navController.navigateForward(['/app/home/edit-post/' + item?.id]);
    } else if (item.type === 'action_point' || item.type === 'adopted_action_point') {
      await this.navController.navigateForward(['/app/action-point/edit-action-point/' + item.id]);
    }
  }

  reportPost(item) {
    this.popoverCtrl.dismiss();
    this.postService.reportPost(item.id).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.globalService.presentToast(result.message);
      }
    });
  }

  hidePost(item) {
    this.popoverCtrl.dismiss();
    this.postService.hidePost(item.id).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.globalService.presentToast(result.message);
        this.auth.userLoggedIn.next('hardreload');
        this.location.back();
      }
    });
  }

  blockUser(item) {
    this.popoverCtrl.dismiss();
    this.userService.apiBlockUser(item.createdBy.id).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.auth.userLoggedIn.next('hardreload');
        this.globalService.presentToast(result.message);
        this.location.back();
      }
    });
  }

  likeComment(comment) {
    this.postService.likeActionComment(comment.id).subscribe((result: any) => {
      if (result.status) {
        this.globalService.presentToast(result.message);
        this.commentsComponent.loadCommentByComponent();
      }
    });
  }


  openCompanyProfile(company: CompanyModel) {
    this.navigationService.openCompanyProfile(company);
  }

  translatePost(item) {

    this.translateFlag = !this.translateFlag;

    if (!item.postTranslations?.title) {
      this.postService.apiTranslatePost(item?.id).subscribe((result: any) => {
        if (result.status) {
          this.item = result.data;
        }
      });
    }
  }

  setRating(event: any) {
    this.setColorOfRatingButton(event.item.star);
    if (event.popupClose) {
      this.item.isRated = event.item.isRated;
      this.item.star = event.item.star;
    }
    this.popoverCtrl.dismiss();
  }

  setColorOfRatingButton(starsAvg) {
    this.colorOfEarth = this.postService.setRatingColor(starsAvg, this.totalUsersRatedCount);
  }

  addAdoptActionPoint(item) {
    if (this.user && this.auth.isAuthenticated) {
      const data = {postId: item?.id};
      if (!item?.isAdopted) {
        this.postService.apiAddAdoptActionPoint(data).subscribe(async (result: ApiResponse) => {
          if (result.status) {
            this.loadActionPoint(item.id);
            if (Capacitor.isNativePlatform() && await this.storage.isInteractionSoundOn()) {
              NativeAudio.play({
                assetId: 'adopt',
                time: 0
              });
            }
            if (this.item.company && this.item?.action_point_type === 'company') {
              await this.globalService.presentToast(this.translate.instant('txt_ap_adopted_from_company'), 4000);
            } else {
              await this.globalService.presentToast(this.translate.instant('txt_ap_adopted'));
            }
          } else {
            await this.globalService.presentToast(this.translate.instant('err_general'));
          }
        });
      } else {
        this.postService.apiRemoveAdoptAP(data).subscribe(async (result: ApiResponse) => {
          if (result.status) {
            this.loadActionPoint(item.id);
            await this.globalService.presentToast(this.translate.instant('txt_ap_unadopted'));
          } else {
            await this.globalService.presentToast(this.translate.instant('err_general'));
          }
        });
      }
    } else {
      this.isAnonymousAction();
    }
  }

  commentSubmit() {
    if (!this.commentForm.valid) {
      this.commentForm.markAllAsTouched();
      return;
    }
    const userTags = [];
    this.userSelectedTags.forEach(element => {
      if (this.commentForm.value.comment.includes('@' + element.username)) {
        userTags.push(element.id);
      }
    });
    this.commentsComponent.commentSubmit(this.commentForm, userTags);
    if (this.item.type === 'action_point') {
      this.loadActionPoint(this.item.id.toString());
    } else if (this.item.type === 'post') {
      this.loadPost(this.item.id.toString());
    }
  }

  setCommentBoxValue(event) {
    if (this.user && this.auth.isAuthenticated) {
      this.commentForm.setValue(event.val);
      if (event.behavior) {
        this.commentInput.nativeElement.scrollIntoView(event.behavior);
        this.commentInput.nativeElement.style.borderColor = event.borderColor;
      }
    } else {
      this.isAnonymousAction();
    }
  }

  focusToCommentBar() {
    this.showCommentBox = !this.showCommentBox;
    if (this.user && this.user.id) {
      setTimeout(() => {
        this.commentInput.nativeElement.focus();
      }, 100);
    } else {
      this.isAnonymousAction();
    }
  }

  cannotAdoptActionPoint() {
    if (this.reasonNotAdoptOwn) {
      this.globalService.presentToast(this.translate.instant('txt_cannot_adopt_your_own'));
    }
  }

  viewAdopt() {
    if (this.user && this.user.id === this.item?.createdBy?.id) {
      this.adoptPost = false;
      this.reasonNotAdoptOwn = true;
    } else if (this.user && this.user.id !== this.item?.createdBy?.id) {
      this.adoptPost = true;
    }
  }

  getContent(item: any) {
    let str = item.description;
    const arrToReturn = [];
    let counter = 0;

    item.userTag.forEach((element, index) => {
      const q = '@' + element.username;
      if (str.indexOf(q) !== -1) {
        const startIndex = str.indexOf(q);
        const endIndex = startIndex + q.length;
        if (str.indexOf(q) === 0) {
          arrToReturn.push(counter);
          str = str.substring(endIndex, str.length);
        } else {
          arrToReturn.push(str.substring(0, startIndex));
          arrToReturn.push(counter);
          str = str.substring(endIndex, str.length);
        }
      }
      if (str.length > 0 && index + 1 === item.userTag.length) {
        arrToReturn.push(str);
      }
      counter++;
    });

    if (counter !== 0 && arrToReturn.length !== 0) {
      return arrToReturn;
    } else {
      arrToReturn.push(str);
      return arrToReturn;
    }
  }

  checkIsString(txt) {
    return typeof txt === 'string';
  }

  async deletePost(item) {
    const alert = await this.alertController.create({
      cssClass: 'remove-action-point-alert',
      header: this.translate.instant('hdl_delete_post'),
      message: this.translate.instant('txt_delete_post'),
      buttons: [
        {
          text: this.translate.instant('lbl_no'),
          role: 'cancel',
          cssClass: 'cancel-button',
          id: 'cancel-button',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('lbl_yes'),
          id: 'confirm-button',
          cssClass: 'confirm-button',
          handler: () => {
            this.apiDeletePost(item);
          }
        }
      ]
    });

    await alert.present();
  }


  apiDeletePost(item) {
    this.popoverCtrl.dismiss();
    this.postService.apiDeletePost(item.id).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.navController.back();
        this.item = null;
        this.globalService.presentToast(this.translate.instant('txt_post_delete_success'));
      } else {
        this.globalService.presentToast(this.translate.instant('txt_post_delete_failure'));
      }
    });
  }

  async openImageLightBox(link) {
    if (this.globalService.isMobile()) {
      this.imageViewModal = await this.modalController.create({
        component: ImageViewerComponent,
        backdropDismiss: true,
        mode: 'ios',
        id: 'imageViewModal',
        componentProps: {
          img: link
        }
      });

      await this.imageViewModal.present();

      await this.imageViewModal.onDidDismiss();
    }
  }

  async sharePost(item: any) {
    const filepath = item && item.media && item.media[0] && item.media[0].path ? item.media[0].path : '';
    await this.shareService.share(item.id, item.title, item.description, item.shareUrl, filepath);
  }

  isAnonymousAction() {
    if (!(this.user && this.auth.isAuthenticated)) {
      this.globalService.openLoginModal();
    }
  }

  protected readonly sdgInactiveArray = sdgInactive;

  async openSheetModal() {
    this.showCommentBox = !this.showCommentBox;
  }

  virtualScrolled(event: any) {
    event.stopPropagation();
  }

  async openGallery(actionPointId: number, momentId: number) {
    this.modalElement = await this.modalController.create({
      component: GalleryModalComponent,
      backdropDismiss: true,
      mode: 'ios',
      id: 'inline-modal',
      cssClass: 'modal-gallery',
      componentProps: {
        momentId: momentId,
        actionPointId: actionPointId,
        actionPointFeed: true
      }
    })
    await this.modalElement.present();
    this.galleryIsOpen = true;
  }


  enterAnimation = (baseEl: HTMLElement) => {
    const root = baseEl.shadowRoot;

    const backdropAnimation = this.animationCtrl
      .create()
      .addElement(root!.querySelector('ion-backdrop')!)
      .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

    const wrapperAnimation = this.animationCtrl
      .create()
      .addElement(root!.querySelector('.modal-wrapper')!)
      .keyframes([
        {
          offset: 0,
          opacity: '0',
          transform: 'translateY(100%) scale(0.9)',
        },
        {
          offset: 1,
          opacity: '0.99',
          transform: 'translateY(0%) scale(1)',
        },
      ]);

    return this.animationCtrl
      .create()
      .addElement(baseEl)
      .easing('ease-out')
      .duration(500)
      .addAnimation([backdropAnimation, wrapperAnimation]);
  };

  leaveAnimation = (baseEl: HTMLElement) => {
    return this.enterAnimation(baseEl).direction('reverse');
  };

  doRefresh(event) {
    setTimeout(() => {
      this.syncFirstLoad();
      event.target.complete();
    }, 1000);
  }

  syncFirstLoad() {
    this.loading = true;
    this.loadPost(this.activatedRoute.snapshot.params.postId);
    this.loadActionPoint(this.activatedRoute.snapshot.params.postId);
  }
}
